module.exports = __webpack_public_path__ + "static/forecast/weather/daycloud-ef63bc9d88bcbd0e33bd475f3a27ff18.svg";